import { render, staticRenderFns } from "./cooperateModel.vue?vue&type=template&id=5bfb5546&scoped=true"
import script from "./cooperateModel.vue?vue&type=script&lang=js"
export * from "./cooperateModel.vue?vue&type=script&lang=js"
import style0 from "./cooperateModel.vue?vue&type=style&index=0&id=5bfb5546&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bfb5546",
  null
  
)

export default component.exports